export default {
    setPlans(state, plans) {
        state.plans = plans;
    },
    setError(state, error) {
        state.error = error.toString();
    },
    setMaterials(state, materials) {
        state.materials = materials;
    },
};
